import { Box } from "@mui/material";


export default function Documentation() {
  return (
    <Box></Box>
  );
}
